import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=6eddc1d2&scoped=true&"
import script from "./CopyButton.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CopyButton.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CopyButton.vue?vue&type=style&index=0&id=6eddc1d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eddc1d2",
  null
  
)

export default component.exports